<template>
  <div id="common-Footer">
      <div class="footer_content" style="background:#263038">
        <div class="aboutWe_wapper">
          <div
            class="about_li"
            @click="foot_skip(1)"
          >关于我们</div>
          <div
            class="about_li"
            @click="foot_skip(2)"
          >联系我们</div>
          <div
            class="about_li"
            @click="foot_skip(3)"
          >用户协议</div>
          <div
            class="about_li about_li_last"
            @click="foot_skip(4)"
          >隐私政策</div>
        </div>
        <div class="company_wapper">
          Copyright © 2020.Beijing Glory PKPM Technology Co.,Ltd. All rights reserved.
          ICP备案:京ICP备17027954号-1
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {}
  },
  methods: {
    foot_skip(value) {
      if (value == 1) {
        window.open('https://www.pkpm.cn/company?type=profile')
      } else if (value == 2) {
        window.open('https://www.pkpm.cn/contactus?type=beijing')
      } else if (value == 3) {
        let routeData = this.$router.resolve({
          name: 'UserAgreenment',
          query: {
            showValue: 1
          }
        })
        window.open(routeData.href, '_blank')
      } else if (value == 4) {
        let routeData = this.$router.resolve({
          name: 'UserAgreenment',
          query: {
            showValue: 2
          }
        })
        window.open(routeData.href, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#common-Footer{
  background: #263038;
  font-family: PingFangSC-Medium;
  font-size: 22px;
  height: 120px;
  color: #ffffff;
  .footer_content {
    margin: 0 auto;
    position: relative;
    height: 100%;
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .aboutWe_wapper {
    display: flex;
    justify-content: center;
    height: 16px;
    .about_li {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      height: 16px;
      line-height: 16px;
      color: rgba(255,255,255,0.65);
      letter-spacing: 0.22px;
      text-align: center;
      width: 128px;
      border-right: 2px solid rgba(255,255,255,0.15);;
      cursor: pointer;
      font-weight: 400;
    }
    .about_li_last {
      border-right: none;
    }
  }

  .company_wapper {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0.22px;
    text-align: center;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue